/* eslint-disable */
import { StyleSheet } from 'react-native'
import { ApplicationStyles } from '../../Themes/'

export default StyleSheet.create({
  ...ApplicationStyles.screen,
  container: {
    flex: 1,
    backgroundColor: 'white'
  },
  loader: {
    position: 'absolute',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0)',
    height: '100%',
    left: 0,
    position: 'absolute',
    top: 0,
    justifyContent: 'center',
    width: '100%',
  },
  endorseLoader: {
    position: 'absolute',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0)',
    height: '50%',
    left: 0,
    position: 'absolute',
    top: 0,
    justifyContent: 'center',
    width: '100%',
  },
})
